<template>
  <div class="viva-tooltip-wrap" @mouseenter="show = true" @mouseleave="show = false">
    <slot />
    <div v-show="show" class="viva-tooltip__bubble" :class="`viva-tooltip__bubble--${placement}`">
      {{ text }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'VivaTooltip',

  props: {
    text: {
      type: String,
      required: true,
    },
    placement: {
      type: String,
      default: 'top',
      validator: (value) => ['top', 'bottom'].includes(value),
    },
  },

  data() {
    return { show: false }
  },
}
</script>

<style scoped>
.viva-tooltip-wrap {
  position: relative;
  display: inline-block;
}

.viva-tooltip__bubble {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  background: #3A3732;
  color: #F5F0E8;
  font-size: 11px;
  line-height: 1.5;
  padding: 8px 12px;
  border-radius: 6px;
  width: 220px;
  z-index: 100;
  pointer-events: none;
  white-space: normal;
}

.viva-tooltip__bubble--top {
  bottom: calc(100% + 6px);
}

.viva-tooltip__bubble--top::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 5px solid transparent;
  border-top-color: #3A3732;
}

.viva-tooltip__bubble--bottom {
  top: calc(100% + 6px);
}

.viva-tooltip__bubble--bottom::after {
  content: '';
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 5px solid transparent;
  border-bottom-color: #3A3732;
}
</style>
